// extracted by mini-css-extract-plugin
module.exports = {"category-container":"CategoryContainer_category-container__18EIL","word-map-container":"CategoryContainer_word-map-container__1HRlq"};